var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.evaluation
      ? _c("section", { attrs: { id: "resume" } }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-6" }, [
              _vm.screenWidth <= 768
                ? _c(
                    "div",
                    [
                      _c("FinancialInformationCard", {
                        attrs: { "read-only": true },
                      }),
                      _c("CreditOfferCard", { attrs: { "read-only": true } }),
                      _c("AssociatedInsuranceCard", {
                        attrs: { "read-only": true },
                      }),
                      _c("GopsCard", { attrs: { "read-only": true } }),
                      _c("LogsCard", { attrs: { evaluation: _vm.evaluation } }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("SimulationCard", { attrs: { "read-only": true } }),
                      _c("PropertyCard", { attrs: { "read-only": true } }),
                      _c("ParamsCard", { attrs: { "read-only": true } }),
                    ],
                    1
                  ),
            ]),
            _c("div", { staticClass: "column is-6" }, [
              _c("div", { staticClass: "columns is-1" }, [
                _c("div", { staticClass: "column is-6-desktop" }, [
                  _c("div", { staticClass: "panel result" }, [
                    _c(
                      "div",
                      { staticClass: "panel-block p-5 has-text-centered" },
                      [
                        _c("p", { staticClass: "commercial-purpose" }, [
                          _vm._v(_vm._s(_vm.commercialPurporse)),
                        ]),
                        _c("small", { staticClass: "has-text-grey-light" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                _vm.getResult(
                                  _vm.evaluation.financingRatio,
                                  _vm.$getSafe(
                                    _vm.evaluation,
                                    "approvedCreditAmount"
                                  )
                                ).label
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "column is-6-desktop" },
                  [
                    _c("Policy", {
                      attrs: { eligibility: _vm.evaluationEligibility },
                    }),
                  ],
                  1
                ),
              ]),
              _vm.isNotEmpty(_vm.evaluationExplanations)
                ? _c("div", { staticClass: "explanations" }, [
                    _c("p", { staticClass: "has-text-weight-medium" }, [
                      _vm._v("La simulación no pudo ser pre-aprobada porque:"),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "fa-ul ml-5" },
                      _vm._l(
                        _vm.evaluationExplanations,
                        function (reason, key) {
                          return _c("li", { key: key }, [
                            _vm._m(0, true),
                            _vm._v(" " + _vm._s(reason) + " "),
                          ])
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm.isNotEmpty(_vm.evaluationMessages)
                ? _c("div", { staticClass: "messages mb-4" }, [
                    _c("p", { staticClass: "has-text-weight-medium" }, [
                      _vm._v("Gestiones a realizar:"),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "fa-ul ml-5" },
                      _vm._l(_vm.evaluationMessages, function (message, key) {
                        return _c("li", { key: key }, [
                          _vm._m(1, true),
                          _vm._v(" " + _vm._s(message) + " "),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm.screenWidth <= 768
                ? _c(
                    "div",
                    [
                      _c("SimulationCard", { attrs: { "read-only": true } }),
                      _c("PropertyCard", { attrs: { "read-only": true } }),
                      _c("ParamsCard", { attrs: { "read-only": true } }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("FinancialInformationCard", {
                        attrs: { "read-only": true },
                      }),
                      _c("CreditOfferCard", { attrs: { "read-only": true } }),
                      _c("AssociatedInsuranceCard", {
                        attrs: { "read-only": true },
                      }),
                      _c("GopsCard", { attrs: { "read-only": true } }),
                      _c("LogsCard", { attrs: { evaluation: _vm.evaluation } }),
                    ],
                    1
                  ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li" }, [
      _c("i", {
        staticClass: "fas fa-circle-arrow-right fa-sm has-text-primary",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "fa-li" }, [
      _c("i", {
        staticClass: "fas fa-circle-arrow-right fa-sm has-text-primary",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }